export const SET_INIT_COVERAGE_LIST = 'SET_INIT_COVERAGE_LIST';
export const SET_COVERAGE_LIST = 'SET_COVERAGE_LIST';
export const SET_COVERAGE_PLAN_TYPE = 'SET_COVERAGE_PLAN_TYPE';
export const SET_PRODUCT = 'SET_PRODUCT';
export const SET_USER_FLOW_TYPE = 'SET_USER_FLOW_TYPE';
export const SET_ERROR_CODE = 'SET_ERROR_CODE';
